import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

interface NoPad {
  noPad?: 'bottom' | 'top' | 'both';
}
interface IPageSection {
  recessed?: boolean;
  noBorder?: boolean;
}

export const PageSectionWrapper = styled.div<IPageSection>`
  position: relative;

  :before {
    position: absolute;
    left: -${layout.measurements.spacing100};
    right: -${layout.measurements.spacing100};
    z-index: -1;
    content: '';
    height: 100%;

    ${p =>
      !p.noBorder &&
      !p.recessed &&
      css`
        border-bottom: 1px solid ${p.theme.lines.primary};
      `};

    ${({ recessed, theme }) =>
      recessed &&
      css`
        background-color: ${theme.bg.quaternary};
      `};

    ${media.largeUp`
      left: -100vw;
      right: -100vw;
    `}
  }
`;

export const PageSectionContent = styled.section<NoPad>`
  ${p => {
    if (p.noPad === 'bottom') {
      return css`
        padding-top: ${layout.measurements.spacing200};
        padding-bottom: 0;
        ${media.mediumUp` 
            padding-top: ${layout.measurements.spacing400};
        `};
      `;
    }
    if (p.noPad === 'top') {
      return css`
        padding-bottom: ${layout.measurements.spacing200};
        padding-top: 0;
        ${media.mediumUp` 
          padding-bottom: ${layout.measurements.spacing400};
        `};
      `;
    }
    if (p.noPad === 'both') {
      return css`
        padding: 0;
      `;
    }

    return css`
      padding: ${layout.measurements.spacing200} 0;
      ${media.mediumUp`
        padding: ${layout.measurements.spacing400} 0;
      `};
    `;
  }};

  :empty {
    display: none;
  }
`;
